<!-- 预配信息-回执日志 -->
<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.ediFeedBackState')"
      width="950px"
      :close-on-click-modal="false"
      class="set-height"
    >
      <el-tabs
        ref="tabs"
        v-model="activeTabName"
        type="card"
      >
        <el-tab-pane :label="$t('SeaExport.sendLog')" name="sendLog">
          <div>
            <cargo-ag-grid
              :grid-options="gridOptions"
              :column-defs="isSeaHouseChannel ? housekeeper : columnDefs"
              :grid-params.sync="gridParams"
              :row-data="rowData"
              style="min-height:300px"
              @gridReady="onGridReady"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('SeaExport.ediFeedBackState')" name="receiptLog">
          <div>
            <cargo-ag-grid
              :grid-options="receiptGridOptions"
              :column-defs="isSeaHouseChannel ? receiptHousekeeper : receiptColumnDefs"
              :grid-params.sync="receiptGridParams"
              :row-data="receiptRowData"
              style="min-height:300px"
              @gridReady="receiptOnGridReady"
            />
          </div>

        </el-tab-pane>
      </el-tabs>

      <div slot="footer" :class="{'footer-layout':isSeaHouseChannel && activeTabName === 'receiptLog'}">
        <span v-show="isSeaHouseChannel && activeTabName === 'receiptLog'" style="float: left">{{ $t('SeaExport.receiptPrompt') }}</span>
        <el-button v-show="isSeaHouseChannel && activeTabName === 'receiptLog'" type="primary" class="can-operate" @click="reload">{{ $t('CargoMsg.Cargo_Refresh') }}</el-button>
        <el-button @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('SeaExport.customsReceipt')"
      :visible.sync="centerDialogVisible"
      width="60%"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      center
    >
      <div>
        <el-table :data="customsReceipt" border>
          <el-table-column prop="customCode" :label="$t('SeaExport.customCode')" />
          <el-table-column prop="transportation" :label="$t('SeaExport.transportation')" width="150" />
          <el-table-column prop="billType" :label="$t('SeaExport.receiptBillType')" />
          <el-table-column prop="transportationName" :label="$t('SeaExport.transportationName')" />
          <el-table-column prop="voyage" :label="$t('SeaExport.receiptVoyage')" />
          <el-table-column prop="importArrivalSignal" :label="$t('SeaExport.importArrivalSignal')" />
        </el-table>
      </div>
      <div style="margin-top:20px;">
        <el-table :data="customsReceipt" border>
          <el-table-column prop="billNumber" :label="$t('SeaExport.receiptBillNumber')" />
          <el-table-column prop="entryDepatureDate" :label="$t('SeaExport.entryDepatureDate')" width="150" />
          <el-table-column prop="itemCount" :label="$t('SeaExport.itemCount')" />
          <el-table-column prop="weight" :label="$t('SeaExport.receiptWeight')" />
          <el-table-column prop="status" :label="$t('SeaExport.tallyStatus')" />
          <el-table-column prop="exportArrivalStatus" :label="$t('SeaExport.exportArrivalStatus')" />
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache } from '@/utils/cacheManager'
import { queryManifestCfmLog } from '@/api/seaExport/manifestInfo'
import { DocumentManage } from '@/utils/commonUtil'
import { querySeaHouseChomanifes, querySeahouseLoadreceipt } from '@/api/seaExport/seaExportJob'
import URL from '@/api/urlTranslator'

export default {
  name: 'EdiFeedBackStateTitleDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true },
    activeTab: { type: String, default: '' },
    manifestInfoUuid: { type: String, required: true },
    isSeaHouseChannel: { type: Boolean, required: true }
  },
  data() {
    return {
      centerDialogVisible: false,
      documentManage: new DocumentManage(),
      innerVisible: false,
      activeTabName: 'sendLog',
      receiptGridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      receiptGridParams: {},
      receiptHousekeeper: [
        {
          headerName: this.$t('SeaExport.returnTime'),
          field: 'outputDate',
          suppressMenu: true,
          width: 130
        }, {
          headerName: this.$t('CargoMsg.Cargo_RefNbr'),
          field: 'soNo',
          suppressMenu: true,
          width: 140
        },
        {
          headerName: this.$t('SeaExport.customsReceiptStatus'),
          field: 'result',
          suppressMenu: true,
          width: 140,
          cellRenderer: (params) => {
            return this.formatStatus(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.loadingManifestReceipt'),
          field: 'loadingManifestReceipt',
          suppressMenu: true,
          hide: false,
          lockVisible: true,
          width: 140,
          cellRenderer: (params) => {
            if (params.value === '2') {
              return this.$t('queryJob.ReceiptSuccessful')
            } else {
              return this.$t('queryJob.WaitingForReceipt')
            }
          }
        },
        {
          headerName: this.$t('SeaExport.customsReceipt'),
          field: 'customsReceipt',
          suppressMenu: true,
          hide: false,
          lockVisible: true,
          width: 140,
          cellRenderer: (params) => {
            if (params.value.length > 0) {
              const openReceipt = this.documentManage.getPath('openReceipt')
              const data = JSON.stringify(params.value).replace(/"/g, '&quot;')
              return `<a onclick="${openReceipt}('${data}')" style="color:#46a6ff">回执成功</a>`
            }
            return this.$t('queryJob.WaitingForReceipt')
          }
        },
        {
          headerName: this.$t('SeaExport.ReturnInformation'),
          field: 'content',
          suppressMenu: true,
          width: 140
        }
        // {
        //   headerName: this.$t('SeaExport.source'),
        //   field: 'type',
        //   suppressMenu: true,
        //   width: 220,
        //   cellRenderer: (params) => {
        //     return this.sourceStatus(params.data)
        //   }
        // }
      ],
      receiptColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Time'),
          field: 'outputDate',
          suppressMenu: true,
          width: 130
        }, {
          headerName: this.$t('CargoMsg.Cargo_RefNbr'),
          field: 'soNo',
          suppressMenu: true,
          width: 140
        },
        {
          headerName: this.$t('SeaExport.ReceiptStatus'),
          field: 'result',
          suppressMenu: true,
          width: 140,
          cellRenderer: (params) => {
            return this.formatStatus(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.ReturnInformation'),
          field: 'content',
          suppressMenu: true,
          width: 220
        }
      ],
      receiptRowData: [],
      customsReceipt: [],
      receiptGridApi: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      housekeeper: [
        {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'SO_NO',
          width: 130
        },
        {
          headerName: this.$t('SeaExport.operationTime'),
          field: 'DATE_CREATED',
          width: 139
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperateBy'),
          field: 'CREATED_BY',
          width: 110,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.operationalMotion'),
          field: 'CONTENT',
          width: 110
        },
        {
          headerName: this.$t('SeaExport.Operation'), field: 'FILE_ID', colId: 'FILE_ID', width: 150, noExport: true,
          cellRenderer: (params) => {
            if (params.value) {
              return `<a href="${URL.common.findByFileId}/${params.value}?sessionId=${this.$store.getters.token}" target="_blank" style="color:blue">${this.$t('FileHistory.fileDownload')}</a>`
            } else {
              return ''
            }
          }
        }
      ],
      columnDefs: [
        {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'SO_NO',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Time'),
          field: 'DATE_CREATED',
          width: 139
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperateBy'),
          field: 'CREATED_BY',
          width: 110,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.Content'),
          field: 'CONTENT',
          width: 231
        }
      ],
      rowData: [],
      gridApi: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.receiptRowData = []
        this.customsReceipt = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
    this.activeTabName = this.activeTab
  },
  beforeMount() {
    const self = this
    this.documentManage.set('openReceipt', (value) => {
      self.openReceipt(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 回执成功查看弹窗
    openReceipt(data) {
      this.centerDialogVisible = true
      this.customsReceipt = JSON.parse(data)
    },
    // isSeaHouseChannel
    sourceStatus(data) {
      if (data.type === 1) {
        return this.$t('SeaExport.NingboEPort')
      }
      if (data.type === 2) {
        return this.$t('SeaExport.SeaHousekeeper')
      }
      if (data.type === 3) {
        return this.$t('SeaExport.Wse')
      }
    },
    receiptOnGridReady(params) {
      this.receiptGridApi = params.api
      this.receiptGridApi.sizeColumnsToFit()
    },
    onGridReady(params) {
      this.gridApi = params.api
    },
    reload() {
      if (this.job.uuid) {
        this.loadSeahouseReceipt()
      }
    },
    toQuery() {
      if (this.job.uuid) {
        new SeaExportJob(this.job).getEdiFeedBackStates().then(res => {
          this.receiptRowData = res
          this.loadSeahouseReceipt()
        })
      } else {
        this.receiptRowData = []
        this.customsReceipt = []
      }
      this.storageURL = cache.config.get('StorageURL')
      if (this.manifestInfoUuid) {
        queryManifestCfmLog({ manifestInfoUuid: this.manifestInfoUuid }).then(res => {
          this.rowData = res.data
        })
      } else {
        this.rowData = []
      }
    },
    formatStatus(data) {
      if (data.type === 2 || data.type === 3) {
        let result = ''
        if (data.code === '1') {
          switch (data.status) {
            case 1:
              result = this.$t('Message.ReceiptSucceeded')
              break
            case 2:
              result = this.$t('SeaExport.Chargeback')
              break
            case 3:
              result = this.$t('Message.ReceiptError')
              break
            default:
              result = ''
          }
        } else if (data.code === '2') {
          switch (data.status) {
            case 1:
              result = this.$t('Message.SubmittedForDeletion')
              break
            case 2:
              result = this.$t('Message.DeleteSuccessfully')
              break
            case 3:
              result = this.$t('Message.DeleteFailed')
              break
            case 4:
              result = this.$t('Message.EditedSuccessfully')
              break
            case 5:
              result = this.$t('Message.ModificationFailed')
              break
            case 6:
              result = this.$t('SeaExport.Chargeback')
              break
            case 7:
              result = this.$t('Message.RevokeTruckOrderSuccess')
              break
            case 8:
              result = this.$t('Message.ShipNotRegistered')
              break
            case 9:
              result = this.$t('Message.Transfer')
              break
            case 10:
              result = this.$t('Message.LoadManifest')
              break
            case 11:
              result = this.$t('Message.ModificationFailed2')
              break
            case 12:
              result = this.$t('Message.ModifiedSuccessfully')
              break

            default:
              result = ''
          }
        }
        return result
      }
    },
    async loadSeahouseReceipt() {
      if (!this.receiptRowData || this.receiptRowData.length === 0) {
        return
      }

      const requests = []
      const chomanifes = {}
      const loadreceipt = {}
      for (const data of this.receiptRowData) {
        const params = {
          jobUuid: this.job.uuid,
          realBillNo: data.realBillNo,
          uuid: data.uuid
        }
        if (!data['customsReceipt']) {
          requests.push(this.loadSeaHouseChomanifes(params, chomanifes))
        }
        if (!data['loadingManifestReceipt']) {
          requests.push(this.loadSeahouseLoadreceipt(params, loadreceipt))
        }
      }
      if (requests.length === 0) {
        return
      }
      // 遍历海管家回调接口
      await Promise.all(requests)
      this.$message.success(this.$t('CargoMsg.Cargo_Loaded'))
      // 遍历数据，组装数据
      for (const data of this.receiptRowData) {
        if (!data['customsReceipt'] && chomanifes[data.uuid]) {
          data['customsReceipt'] = chomanifes[data.uuid]
        }
        if (!data['loadingManifestReceipt'] && loadreceipt[data.uuid]) {
          data['loadingManifestReceipt'] = loadreceipt[data.uuid]
        }
      }
      this.receiptGridOptions.api.setRowData(this.receiptRowData)
      this.receiptGridOptions.api.refreshCells({ force: true })
    },
    async loadSeaHouseChomanifes(params, map) {
      await querySeaHouseChomanifes(params).then(async res => {
        map[params.uuid] = res.data
      })
    },
    async loadSeahouseLoadreceipt(params, map) {
      await querySeahouseLoadreceipt(params).then(async res => {
        map[params.uuid] = res.data
      })
    }
  }
}
</script>

<style lang="scss">
.set-height{
  .cargo-ag-grid{
    .ag-theme-balham{
      .ag-root-wrapper-body {
        .ag-layout-normal{
          min-height: 245px !important;
        }
      }
    }
  }
  .footer-layout{
    justify-content: space-between;
  }
}
</style>
